module.exports = __webpack_public_path__ + "static/img/13.96966b0c.jpg";